import useSWR from 'swr';
import axios from 'axios'
import { bacchusAPIEndpoint } from '../config';

const fetcher = url => axios.get(url).then(res => res.data)

function useApi (endpoint) {
    const { data, error } = useSWR(bacchusAPIEndpoint + endpoint, fetcher)
    return {
      data,
      isLoading: !error && !data,
      isError: error
    }
  }

  export default useApi;